import marked from 'marked'
import ReactHtmlParser from 'react-html-parser'
import { removeWidows } from 'string-remove-widows'

export const widont = (string = null) => {
  if (!string) return

  return ReactHtmlParser(removeWidows(string).res)
}

export const formatMarkdown = str => {
  const renderer = new marked.Renderer()
  renderer.link = (href, title, text) =>
    `<a target="_blank" href="${href}" title="${title}">${text}</a>`

  return marked(str, { renderer })
}
